<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs display-lift-v3-container"
>
	<div class="cards-holder">
		<div class="card card2 mRight" #chartcontainer>
			<app-loader [showLoader]="showLoad"></app-loader>
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
			>
				<div class="o-stack__cell">
					<h5 class="card-title">{{ sectiontitle }}</h5>
					<span class="datatable-icon" *ngIf="hasData && tableConfig.enableDownload && !isPlatform">
						<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
					<div class="switch_position">
						<span class="label_font">Platforms</span>
						<label class="switch col-md-8">
							<input type="checkbox" (change)="toggleMode()" />
							<span class="slider round"></span>
						</label>
						<span class="label_font">Networks</span>
					</div>
				</div>
			</div>
			<div class="analytics-portlet-content">
				<ngx-datatable
					class="material"
					[columns]="dataTableObj.columns"
					[rows]="isPlatform ? newTableDataPlatform.data : newTableDataNetwork.data"
					[scrollbarV]="true"
					[sortType]="'single'"
					[cssClasses]="cssClasses"
					[columnMode]="'force'"
					[headerHeight]="50"
					[footerHeight]="0"
					[rowHeight]="55"
					[reorderable]="reorderable"
				>
					<ngx-datatable-column
						name="{{ column.name }}"
						prop="{{ column.columnKey }}"
						class="{{ column.cellClass }} r4-datatable-column"
						[headerClass]="column.columnKey"
						*ngFor="let column of dataTableObj.columns; let i = index"
						[sortable]="true"
					>
						<ngx-datatable-column
							name="{{ column.name }}"
							prop="{{ column.prop }}"
							[resizeable]="true"
							[sortable]="true"
							[cellClass]="column.cellClass"
							[headerClass]="column.headerClass"
							[comparator]="column.comparator"
						>
							<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
								<div *ngIf="column.name === 'Platform' || column.name === 'Network'; else nonPlatform">
									<span (click)="customSort('name')" class="r4-cursor" *ngIf="!column.columnHasTooltip; else elseBlock">
										{{ column.name }}
									</span>
								</div>
								<ng-template #nonPlatform>
									<span
										(click)="customSort(colHeader.name)"
										class="r4-cursor"
										*ngIf="!column.columnHasTooltip; else elseBlock"
									>
										{{ colHeader.name }}
									</span>
								</ng-template>
								<ng-template #elseBlock>
									<span class="r4-cursor">
										<span *ngIf="column.name === 'Platform'; else nonPlatformElse">
											<span (click)="customSort('name')" appTooltip *ngIf="!column.columnHasTooltip; else elseBlock">
												{{ colHeader.name }}
											</span>
										</span>
										<ng-template #nonPlatformElse>
											<span
												(click)="customSort(colHeader.name)"
												appTooltip
												*ngIf="!column.columnHasTooltip; else elseBlock"
											>
												{{ colHeader.name }}
											</span>
										</ng-template>
									</span>
								</ng-template>
							</ng-template>
						</ngx-datatable-column>

						<ng-template ngx-datatable-cell-template let-value="value" let-rowIndex="rowIndex" let-row="row">
							<div class="r4-datatable-row">
								<span *ngIf="column.name === 'Platform' || column.name === 'Network'">
									<div class="network-logo"><img [src]="row['logo_path']" width="40" /></div>
									<div class="network-name" [title]="row[name]">{{ row['name'] }}</div>
								</span>
								<span [title]="row[column.prop]">{{ row[column.prop] }}</span>
								<div class="progressbar" *ngIf="column.hasProgressBar && row[column.prop] !== '--'">
									<div class="bar primary-color-bg" [ngStyle]="getPercentage(row, column.prop)"></div>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</div>
		<div class="card1 mLeft lift-right" *ngIf="!is_card_mleft_not_required"></div>
	</div>
</div>
